import { impersonateUser } from "@/be/commands/system-commands";
import { CLM } from "@/common/schema/claims";
import { toRawImpersonateUser } from "@/common/schema/commands/System/ImpersonateUser";
import { SYS } from "@/common/schema/system";
import { urls } from "@/common/urls";
import { endMonitorLoggedInUser } from "@/fe/datadog-context";
import { SERVICES } from "@/fe/services";
import { useSession } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";
import { impersonateCommandFor } from "./impersonateCommandFor";

export function useRunImpersonate(): (targetUserId?: SYS.UserId) => Promise<void> {
  const { CTX }       = SERVICES();
  const { superUser } = CTX.useLoggedInContext();
  const router        = useRouter();
  const searchParams  = useSearchParams();
  const { update }    = useSession();

  const ts   = searchParams.get('ts') || "NOW";
  const URLS = urls({ ts });

  return async (targetUserId?: SYS.UserId) => {
    const command = impersonateCommandFor(targetUserId, CLM.toSystemUserId(superUser.id));
    await impersonateUser({ command: toRawImpersonateUser(command) });
    await update();
    endMonitorLoggedInUser();
    router.push(URLS.root({ ts: "NOW" })); //Push to NOW forces full page reload
  };
}
